<template>
  <div>
    <ejs-dropdownlist
      :fields='fields'
      :dataSource='data.datasource'
      :placeholder='data.placeholder'
      :allowCustom='allowCustom'
      :enabled='data.enabled'
      :name='data.name'
      v-model='data.value'>
    </ejs-dropdownlist>
  </div>
</template>
<script>
export default {
  name: 'FormSelect',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    opCode: {
      type: String,
      default: ''
    },
    defaultData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      allowCustom: true,
      fields: { text: 'showName', value: 'value' },
    };
  },
  beforeMount() {
    const data = JSON.stringify(this.defaultData) !== '{}' ? JSON.parse(this.defaultData.paramsJson) : '';
    this.data.value = (data && data[this.data.name]) ? data[this.data.name] : this.data.value;
    // this.data.enabled = JSON.stringify(this.defaultData) !== '{}' ? false : this.data.enabled;
    this.data.enabled = this.opCode === 'detail' ? false : this.data.enabled;
  }
};
</script>

<style>

</style>
